export default "__VITE_ASSET__BboyJDr6__"